import { SvgIcon, SvgIconProps } from "@mui/material";

export const DocumentationIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M17.176 24.162a1.167 1.167 0 0 1-.825.342H14v-2.35c0-.31.123-.607.342-.826l7.897-7.903a2.008 2.008 0 0 1 2.84 0v0a2.007 2.007 0 0 1 0 2.84l-7.903 7.897Z"
        clipRule="evenodd"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="m19.33 16.346 2.836 2.835M24.167 17.169l1.05 1.05v0c.553.554.553 1.45 0 2.004l-1.914 1.915M8.175 10.496h7M8.175 15.17h4.666M10.5 24.5H7A3.5 3.5 0 0 1 3.5 21V7A3.5 3.5 0 0 1 7 3.5h14A3.5 3.5 0 0 1 24.5 7v2.333"
      />
    </svg>
  </SvgIcon>
);
